import { useSafePush } from '../../hooks/useSafePush'
import Box, { BoxProps } from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { getTimeFilterHref } from '@/helpers/filters'
import { TimeFilterType } from '@/interfaces/filters'

interface TimeFilterProps extends BoxProps {
  timeFilter: TimeFilterType
}

export const TimeFilter = ({ timeFilter = 'all', ...props }: TimeFilterProps): React.ReactElement => {
  const { asPath } = useRouter()
  const { safePush } = useSafePush()

  const { t } = useTranslation('filters')

  const handleChange = (event: any): void => {
    const href = getTimeFilterHref(event.target.value, asPath)
    safePush(href)
  }

  return (
    <Box {...props}>
      <Select value={timeFilter} onChange={handleChange} qa-attribute="timeFilter" sx={{ height: '40px' }}>
        <MenuItem value="all">{t('allTime')}</MenuItem>
        <MenuItem value="week">{t('lastWeek')}</MenuItem>
        <MenuItem value="month">{t('lastMonth')}</MenuItem>
        <MenuItem value="year">{t('lastYear')}</MenuItem>
      </Select>
    </Box>
  )
}
